<template>
  <div class="one-to-one-agenda-blocks-section" v-loading="loading">
    <el-card
      v-loading="loading"
      v-if="!blocks.length"
      class="template-card"
    >
      <div class="el-table__empty-block" style=""><span class="el-table__empty-text">Блоки повестки не добавлены</span></div>
    </el-card>

    <agenda-block-item
      v-for="block in blocks"
      :key="block.id"
      :block="block"
      :meeting="meeting"
      @delete="deleteBlock"
      @add-agreement="openAgreementDialog"
    />

    <el-button
      v-if="$canAndRulesPass(meeting, $permissions.ONE_TO_ONE.AGENDA_BLOCK_MANAGE)"
      size="small"
      type="primary"
      icon="fas fa-plus"
      style="margin-top: 20px"
      @click="showAddDialog = true"
    >
      Добавить блок
    </el-button>


    <el-dialog
      title="Добавить блок повестки"
      :visible.sync="showAddDialog"
      width="440px"
      :close-on-click-modal="false"
      @closed="resetAddForm"
    >
      <el-form ref="addForm" :model="addForm" :rules="addRules" label-position="top">
        <el-form-item label="Название блока" prop="name">
          <el-input v-model="addForm.name" placeholder="Например: Прогресс по целям" />
        </el-form-item>
        <el-form-item label="Рекомендуемая длительность (мин.)">
          <el-input-number v-model="addForm.recommended_duration" :min="1" :step="5" />
        </el-form-item>
        <el-form-item label="Содержание / готовые фразы">
          <el-input v-model="addForm.content" type="textarea" :rows="3" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showAddDialog = false">Отмена</el-button>
        <el-button type="primary" :loading="adding" @click="addBlock">Добавить</el-button>
      </div>
    </el-dialog>


    <el-dialog
      title="Добавить договорённость"
      :visible.sync="showAgreementDialog"
      width="440px"
      :close-on-click-modal="false"
      @closed="resetAgreementForm"
    >
      <el-form ref="agreementForm" :model="agreementForm" :rules="agreementRules" label-position="top">
        <el-form-item label="Содержание договорённости" prop="content">
          <el-input v-model="agreementForm.content" type="textarea" :rows="3" placeholder="Что договорились сделать?" />
        </el-form-item>
        <el-form-item label="Срок выполнения" prop="deadline">
          <el-date-picker
            v-model="agreementForm.deadline"
            type="date"
            placeholder="Дата"
            format="dd.MM.yyyy"
            value-format="yyyy-MM-dd"
            style="width: 100%"
          />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showAgreementDialog = false">Отмена</el-button>
        <el-button type="primary" :loading="addingAgreement" @click="saveAgreement">Добавить</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import AgendaBlockItem from './AgendaBlockItem.vue';

export default {
  name: 'AgendaBlocksSection',
  components: { AgendaBlockItem },

  props: {
    meeting: { type: Object, required: true },
  },

  data() {
    return {
      loading: false,
      blocks: [],

      showAddDialog: false,
      adding: false,
      addForm: { name: '', recommended_duration: 15, content: '' },
      addRules: {
        name: [{ required: true, message: 'Введите название блока' }],
      },

      showAgreementDialog: false,
      addingAgreement: false,
      currentBlockForAgreement: null,
      agreementForm: { content: '', deadline: null },
      agreementRules: {
        content:  [{ required: true, message: 'Введите содержание' }],
        deadline: [{ required: true, message: 'Укажите срок выполнения' }],
      },
    };
  },

  mounted() {
    this.load();
  },

  methods: {
    load() {
      this.loading = true;
      this.$api.oneToOne.agendaBlockGetByMeeting({
        meeting_id: this.meeting.id,
        expand: 'notes,agreements',
      })
        .then(data => {
          this.blocks = data.blocks;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    addBlock() {
      this.$refs.addForm.validate(valid => {
        if (!valid) return;
        this.adding = true;
        this.$api.oneToOne.agendaBlockCreate({
          meeting_id:           this.meeting.id,
          name:                 this.addForm.name,
          recommended_duration: this.addForm.recommended_duration,
          content:              this.addForm.content,
          order:                this.blocks.length + 1,
        })
          .then(data => {
            this.blocks.push({ ...data.block, notes: [], agreements: [] });
            this.showAddDialog = false;
          })
          .finally(() => {
            this.adding = false;
          });
      });
    },

    resetAddForm() {
      this.addForm = { name: '', recommended_duration: 15, content: '' };
      this.$refs.addForm?.clearValidate();
    },

    deleteBlock(block) {
      this.$api.oneToOne.agendaBlockDelete({ id: block.id })
        .then(() => {
          const idx = this.blocks.findIndex(b => b.id === block.id);
          if (idx !== -1) this.blocks.splice(idx, 1);
        });
    },

    openAgreementDialog(block) {
      this.currentBlockForAgreement = block;
      this.showAgreementDialog = true;
    },

    saveAgreement() {
      this.$refs.agreementForm.validate(valid => {
        if (!valid) return;
        this.addingAgreement = true;
        this.$api.oneToOne.agreementCreate({
          block_id: this.currentBlockForAgreement.id,
          content:  this.agreementForm.content,
          deadline: this.agreementForm.deadline,
        })
          .then(data => {
            if (!this.currentBlockForAgreement.agreements) {
              this.$set(this.currentBlockForAgreement, 'agreements', []);
            }
            this.currentBlockForAgreement.agreements.push(data.agreement);
            this.showAgreementDialog = false;
          })
          .finally(() => {
            this.addingAgreement = false;
          });
      });
    },

    resetAgreementForm() {
      this.agreementForm = { content: '', deadline: null };
      this.currentBlockForAgreement = null;
      this.$refs.agreementForm?.clearValidate();
    },
  },
};
</script>

<style lang="scss" scoped>
.one-to-one-agenda-blocks-section {
  padding-top: 8px;
}
.section-toolbar {
  margin-bottom: 16px;
}
</style>